"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _encodeQuery = _interopRequireDefault(require("../utils/encodeQuery"));

class Uri {
  /**
   * Represent the scheme.
   * @protected
   * @type {string}
   * @see https://tools.ietf.org/html/rfc3986#section-3.1
   */

  /**
   * Represent the user information (user and password).
   * @protected
   * @type {{ user: string; password: string }}
   * @see https://tools.ietf.org/html/rfc3986#section-3.2.1
   */

  /**
   * Represent the host.
   * @protected
   * @type {string}
   * @see https://tools.ietf.org/html/rfc3986#section-3.2.2
   */

  /**
   * Represent the port.
   * @protected
   * @type {number}
   * @see https://tools.ietf.org/html/rfc3986#section-3.2.3
   */

  /**
   * Represent the path.
   * @protected
   * @type {string}
   * @see https://tools.ietf.org/html/rfc3986#section-3.3
   */

  /**
   * Represent the query.
   * @protected
   * @type {string}
   * @see https://tools.ietf.org/html/rfc3986#section-3.4
   */

  /**
   * Represent the fragment.
   * @protected
   * @type {string}
   * @see https://tools.ietf.org/html/rfc3986#section-3.5
   */

  /**
   * @param {string} scheme
   * @param {string | { username: string; password: string }} userInfo
   * @param {string} host
   * @param {number} port
   * @param {string} path
   * @param {string} query
   * @param {string} fragment
   */
  constructor(scheme, userInfo, host, port, path, query, fragment) {
    this.scheme = void 0;
    this.userInfo = void 0;
    this.host = void 0;
    this.port = void 0;
    this.path = void 0;
    this.query = void 0;
    this.fragment = void 0;
    this.setScheme(scheme);
    this.setUserInfo(userInfo);
    this.setHost(host);
    this.setPath(path);
    this.setPort(port);
    this.setQuery(query);
    this.setFragment(fragment);
  }

  clone() {
    const uri = new Uri(this.scheme, this.userInfo, this.host, this.port, this.path, this.query, this.fragment);
    return uri;
  }
  /**
   * @param {string} fragment
   */


  setFragment(fragment = null) {
    this.fragment = fragment;
    return this;
  }
  /**
   * @return {string}
   */


  getFragment() {
    return this.fragment;
  }
  /**
   * @param {string} host
   */


  setHost(host = null) {
    this.host = null !== host ? host.toLowerCase() : null;
    return this;
  }
  /**
   * @return {string}
   */


  getHost() {
    return this.host;
  }
  /**
   *
   * @param {string} path
   */


  setPath(path = null) {
    this.path = path;
    return this;
  }
  /**
   * @return {string}
   */


  getPath() {
    return this.path;
  }
  /**
   * @param {number} port
   */


  setPort(port = null) {
    this.port = port;
    return this;
  }
  /**
   * @return {number}
   */


  getPort() {
    return this.port;
  }
  /**
   * @param {string} query
   */


  setQuery(query = null) {
    this.query = null !== query && "object" === typeof query ? (0, _encodeQuery.default)(query) : query;
    return this;
  }
  /**
   * @return {string}
   */


  getQuery() {
    return this.query;
  }
  /**
   * @param {string} scheme
   */


  setScheme(scheme = null) {
    this.scheme = scheme;
    return this;
  }
  /**
   * @return {string}
   */


  getScheme() {
    return this.scheme;
  }
  /**
   *
   * @param {string | { username: string; password: string }} userInfo
   */


  setUserInfo(userInfo = null) {
    let user = "";
    let password = "";

    if (null !== userInfo) {
      if ("object" === typeof userInfo) {
        ({
          user = "",
          password = ""
        } = userInfo);
      } else if ("string" === typeof userInfo) {
        [user, password = ""] = userInfo.split(":");
      }

      this.userInfo = user === "" ? null : `${user}${password !== "" ? `:${password}` : ""}`;
    } else {
      this.userInfo = null;
    }

    return this;
  }
  /**
   * @return {string}
   */


  getUserInfo() {
    return this.userInfo;
  }
  /**
   * @return {string}
   */


  getAuthority() {
    let authority = "";
    const host = this.getHost();
    const userInfo = this.getUserInfo();
    const port = this.getPort();

    if (null !== host) {
      authority += host;
    }

    if (userInfo !== null && userInfo !== "") {
      authority = `${userInfo}@${authority}`;
    }

    if (port !== null) {
      authority += `:${port}`;
    }

    return authority;
  }
  /**
   * @param {object} options
   * @param {boolean} [options.useTrailingSlash=false]
   * @param {boolean} [options.useDoubleSlash=false]
   * @return {string}
   */


  toString(options = {}) {
    const {
      useTrailingSlash = false,
      useDoubleSlash = false
    } = options;
    let uri = "";
    const scheme = this.getScheme();
    const authority = this.getAuthority({
      useDoubleSlash
    });
    const path = this.getPath();
    const query = this.getQuery();
    const fragment = this.getFragment();

    if (null !== scheme) {
      uri += `${scheme}:`;
    }

    if (useDoubleSlash || authority !== "") {
      /**
       * Append "//" only if authority exists.
       * @see http://tools.ietf.org/html/rfc3986#section-3
       */
      if (null !== scheme) {
        uri += "//";
      }

      uri += authority;
    }

    if (null !== path) {
      uri += path;
    }

    if ("" !== authority || null !== path) {
      if (useTrailingSlash && "/" !== uri.slice(-1)) {
        uri += "/";
      }

      if ("" !== (query != null ? query : "")) {
        uri += `?${query}`;
      }

      if ("" !== (fragment != null ? fragment : "")) {
        uri += `#${fragment}`;
      }
    }

    return uri;
  }

}

exports.default = Uri;